




































































































































































import Vue from 'vue';
import EnemyDetail from '@/components/enemy/EnemyDetail.vue';
import EnemyTooltip from '@/components/enemy/EnemyTooltip.vue';
import Const, { CELL_TYPE } from '@/classes/const';
import EnemyFleet, { EnemyFleetBuilder } from '@/classes/enemy/enemyFleet';
import Enemy from '@/classes/enemy/enemy';
import EnemyMaster from '@/classes/enemy/enemyMaster';

export default Vue.extend({
  name: 'EnemyFleet',
  components: {
    EnemyDetail,
    EnemyTooltip,
  },
  props: {
    value: {
      type: EnemyFleet,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    handleShowEnemyList: {
      type: Function,
      required: true,
    },
    handleShowItemList: {
      type: Function,
      required: true,
    },
    handleShowWorldList: {
      type: Function,
      required: true,
    },
    capturing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    formations: Const.FORMATIONS,
    cellTypes: Const.CELL_TYPES,
    detailDialog: false,
    destroyDialog: false,
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipEnemy: new Enemy(),
    tooltipX: 0,
    tooltipY: 0,
  }),
  computed: {
    fleet(): EnemyFleet {
      return this.value;
    },
    existEnemy() {
      return this.value.enemies.find((v) => v.data.id);
    },
  },
  methods: {
    showItemList(enemyIndex: number, slotIndex: number) {
      this.handleShowItemList(this.index, enemyIndex, slotIndex);
    },
    showEnemyList(index: number) {
      this.clearTooltip();
      this.handleShowEnemyList(this.index, index);
    },
    async clickedInfo() {
      this.detailDialog = true;
      this.destroyDialog = false;
    },
    setFleet(fleet?: EnemyFleet) {
      if (fleet === undefined) {
        this.$emit('input', new EnemyFleet({ fleet: this.fleet }));
      } else {
        this.$emit('input', fleet);
      }
    },
    resetFleet() {
      this.setFleet(new EnemyFleet());
    },
    changedCombo() {
      const enemyFleet = this.fleet;
      const isUnion = enemyFleet.cellType === CELL_TYPE.GRAND;
      const enemies = enemyFleet.enemies.concat();
      if (isUnion && enemyFleet.enemies.length <= 6) {
        for (let i = 0; i < 6; i += 1) {
          enemies.push(new Enemy(new EnemyMaster(), [], true));
        }
      } else if (!isUnion && enemyFleet.enemies.length > 6) {
        for (let i = 0; i < 6; i += 1) {
          enemies.pop();
        }
      }
      const builder: EnemyFleetBuilder = { fleet: enemyFleet, enemies };
      this.setFleet(new EnemyFleet(builder));
    },
    removeEnemy(index: number) {
      const enemies = this.fleet.enemies.concat();
      enemies[index] = new Enemy();
      const builder: EnemyFleetBuilder = { fleet: this.fleet, enemies };
      this.setFleet(new EnemyFleet(builder));
    },
    toggleDetailDialog() {
      if (!this.detailDialog) {
        setTimeout(() => {
          this.destroyDialog = true;
        }, 100);
      } else {
        this.destroyDialog = false;
      }
    },
    showWorldList() {
      this.handleShowWorldList(this.index);
    },
    closeDetail() {
      this.detailDialog = false;
      this.toggleDetailDialog();
    },
    bootTooltip(enemy: Enemy, e: MouseEvent) {
      if (!enemy.data.id) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).getElementsByClassName('enemy-air-power')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = rect.x + rect.width;
        this.tooltipY = rect.y + rect.height;
        this.tooltipEnemy = enemy;
        this.enabledTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
